module.exports = __webpack_public_path__ + "img/smartcells.c11a8894.png";